export const NAVIGATION_PANEL_MIN_WIDTH_PX = 300;
export const NAVIGATION_PANEL_MAX_WIDTH_PX = 500;
export const NAVIGATION_TOP_BAR_HEIGHT_PX = 45;

export const FILTER_SECTION_MIN_WIDTH_PX = 212;
export const FILTER_SECTION_MAX_WIDTH_PX = 350;
